<template>
    <div class="bg-eidTrustGreen-10 p-[30px] mb-2 mt-auto" data-test-id="turn-off-notification-note">
        <strong>Note:</strong> If you have turned off your notifications for a period of time, any entities who
        may have received notifications during that period will not receive retroactive emails once
        notifications are turned back on.
    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({ name: 'NotificationsOffNote' });
</script>
